import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSelectModule,
    MatSortModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatTableModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatStepperModule,
    MatTabsModule,
    MatIconModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatListModule,
    MatSidenavModule,
    MatInputModule,
    MatButtonToggleModule,
    MatMenuModule
  ],
  exports: [
    MatFormFieldModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSelectModule,
    MatSortModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatTableModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatStepperModule,
    MatTabsModule,
    MatIconModule,
    MatToolbarModule,
    MatDatepickerModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatListModule,
    MatSidenavModule,
    MatInputModule,
    MatButtonToggleModule,
    MatMenuModule
  ],
})
export class MaterialModule { }